import { memo } from 'react';

import { useMarkNotificationsRead } from 'my-core/hooks';

export default memo(function MarkNotificationsRead({ groupKey, type }) {
  useMarkNotificationsRead(type, groupKey);
  return null;
});
